<template>
  <!-- About me widget -->

  <div class="mt-2 py-3 text-center travel-itinerary">
    <h3 class="h4 mb-4">Me and Travel Trail</h3>
    <p class="text-sm">
      I am an adventurous nomad who loves to explore new places, experience
      diverse customs, cultures and create wonderful memories for the entire
      family.
    </p>
    <p class="text-sm">
      After significant changes in my life in December 2023, I found myself at a
      crossroads, eager to give shape to long-neglected hobbies and interests.
      This led to the creation of Travel Trail – a digital platform that
      combines my love for photography with the excitement for travel
      adventures.
    </p>
    <p class="text-sm">
      <a href="/">Travel Trail</a> is full of exploration. It's a place where
      you will find recommended top family travel destinations, family travel
      experiences that can inspire you along your travel trails, tips for
      traveling with kids, kid-friendly activities while traveling and so much
      more. Join me on these amazing trips around the world!
    </p>
    <ul class="list-inline text-sm mb-0">
      <li class="list-inline-item">
        <a
          class="reset-anchor"
          href="https://www.facebook.com/ioana.ciutac/"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fab fa-facebook-f"></i
        ></a>
      </li>
      <li class="list-inline-item">
        <a
          class="reset-anchor"
          href="https://www.instagram.com/traveltrailadventures/"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fab fa-instagram"></i
        ></a>
      </li>
      <li class="list-inline-item">
        <a
          class="reset-anchor"
          href="https://www.youtube.com/@TravelTrailAdventures"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fab fa-youtube"></i
        ></a>
      </li>
      <li class="list-inline-item">
        <a
          class="reset-anchor"
          href="https://www.tripadvisor.com/Profile/traveltrailblog"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fab fa-tripadvisor"></i
        ></a>
      </li>
      <li class="list-inline-item">
        <a
          class="reset-anchor"
          href="https://www.pinterest.com/traveltrailadventures/"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fab fa-pinterest"></i
        ></a>
      </li>
    </ul>
  </div>
  <div class="mb-5">
    <h3 class="h5 py-3 text-center">Follow me on Instagram</h3>
    <p class="text-sm">
      🌍✈️ Join the adventure! Explore the world with me on Instagram.
    </p>
    <div class="row gx-0">
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/agia-napa-village.webp"
              alt="Agia Napa"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/msc-cruise.webp"
              alt="MSC Cruise"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/lefkara-village.webp"
              alt="Lefkara village"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/belis-romania.webp"
              alt="Belis Romania"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/budapest-hotel.webp"
              alt="Budapest Hotel"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/vienna.webp"
              alt="Vienna"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/romania-castle.webp"
              alt="Romania"
            />
          </div>
        </a>
      </div>
      <div class="col-3">
        <a
          class="instagram-item overlay-hover-dark-sm d-block w-100"
          href="https://www.instagram.com/traveltrailadventures/"
        >
          <div class="overlay-content">
            <img
              loading="lazy"
              class="img-fluid"
              src="/img/sibiu-romania.webp"
              alt="Romania"
            />
          </div>
        </a>
      </div>
    </div>
    <h3 class="h5 py-3 text-center">Copyright</h3>
    <p class="text-sm copyright-text">
      The materials posted on this website are exclusively owned by me and are
      protected under copyright law. Their reproduction is permissible only with
      the written consent of the author and must include proper source citation.
      Following the reproduction of any text, it is required to include a
      hyperlink to this blog.
    </p>
    <h3 class="h5 py-3 text-center">Explore more destinations</h3>
    <div class="copyright-text text-center">
      <destinations-component />
    </div>
    <div class="text-center py-3">
      <subscribe-sidebar />
    </div>
  </div>
</template>
<script>
import DestinationsComponent from "@/components/templates/DestinationsComponent";
import SubscribeSidebar from "./SubscribeSidebar";
export default {
  name: "SidebarComponent",
  components: {
    SubscribeSidebar,
    DestinationsComponent,
  },
};
</script>
